/* eslint-disable react/no-array-index-key */
import React, { cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from '@jd/jmtd-tools/es/classnames';
import ConfigConsumer from '../ConfigConsumer';
export default function FormControlButton(_ref) {
  var style = _ref.style,
      children = _ref.children,
      className = _ref.className,
      showControl = _ref.showControl,
      control = _ref.control,
      icon = _ref.icon,
      size = _ref.size,
      outline = _ref.outline,
      disabled = _ref.disabled,
      checked = _ref.checked,
      onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(ConfigConsumer, {
    size: size
  }, function (_ref2) {
    var configSize = _ref2.size;
    return /*#__PURE__*/React.createElement("label", {
      style: style,
      className: classNames('jmtd-form-control-button', 'jmtd-form-control-button-like', className, {
        'jmtd-form-control-button-large': configSize === 'large',
        'jmtd-form-control-button-small': configSize === 'small',
        'jmtd-form-control-button-mini': configSize === 'mini',
        'jmtd-form-control-button-primary': checked,
        'jmtd-form-control-button-default': !checked,
        'jmtd-form-control-button-outline': outline,
        'jmtd-button-outline': outline,
        'jmtd-form-control-button-show-control': showControl,
        'jmtd-form-control-button-disabled': disabled
      }),
      "data-event-content": true,
      "data-event-name": checked ? 'uncheck' : 'check',
      onClick: onClick
    }, control, !showControl && icon && /*#__PURE__*/cloneElement(icon, {
      className: classNames(icon.props.className, 'jmtd-form-control-button-icon')
    }), /*#__PURE__*/React.createElement("span", {
      className: "jmtd-form-control-button-label"
    }, children));
  });
}
FormControlButton.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  icon: PropTypes.node,
  size: PropTypes.oneOf(['large', 'middle', 'small', 'mini']),
  outline: PropTypes.bool,
  disabled: PropTypes.bool,
  style: PropTypes.any,
  checked: PropTypes.bool,
  showControl: PropTypes.bool,
  control: PropTypes.node,
  onClick: PropTypes.func
};
FormControlButton.defaultProps = {
  children: null,
  className: null,
  icon: null,
  size: null,
  outline: false,
  disabled: false,
  style: {},
  checked: false,
  showControl: false,
  control: null,
  onClick: undefined
};